import type { ValueFormat } from "./types";

const ABBREVIATIONS: Array<[number, string]> = [
  [1e12, "T"],
  [1e9, "B"],
  [1e6, "M"],
  [1e3, "K"],
];

function trim(value: number, digits: number): string {
  return Number(value.toFixed(digits)).toString();
}

/** 2433748210 -> "2.43B"; 950 -> "950". */
export function abbreviate(value: number): string {
  const abs = Math.abs(value);
  for (const [size, suffix] of ABBREVIATIONS) {
    if (abs >= size)
      return `${trim(value / size, abs / size >= 100 ? 1 : 2)}${suffix}`;
  }
  return trim(value, 2);
}

/**
 * Format a plotted value for axis ticks (compact) or tooltips (exact).
 * `percent` expects values already in percent units (95.87 -> "95.87%").
 */
export function formatValue(
  value: unknown,
  format: ValueFormat,
  mode: "axis" | "tooltip" = "axis"
): string {
  if (typeof value !== "number" || !Number.isFinite(value)) return "–";
  switch (format) {
    case "percent":
      return `${trim(value, 2)}%`;
    case "currency":
      return mode === "axis"
        ? `$${abbreviate(value)}`
        : value.toLocaleString("en-US", { style: "currency", currency: "USD" });
    case "decimal":
      return value.toLocaleString("en-US", { maximumFractionDigits: 4 });
    case "number":
      return value.toLocaleString("en-US", { maximumFractionDigits: 2 });
    case "abbrev":
    default:
      return mode === "axis"
        ? abbreviate(value)
        : value.toLocaleString("en-US", { maximumFractionDigits: 2 });
  }
}
